import styled, { css } from 'styled-components';
import { MordenCard } from '../../../atoms/modern-card/modern-card';

export const Fieldset = styled(MordenCard)`
  margin-top: 12px;

  legend {
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 8px;
  }

  .grid {
    display: grid;
    gap: 10px;
  }

  @media (min-width: 600px) {
    .grid-2 {
      grid-template-columns: 1fr 1fr;
    }

    .grid-3 {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
`;

export const InputWrap = styled.div`
  position: relative;

  label {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--muted);
    font-size: 14px;
    transition: all 0.15s ease;
    pointer-events: none;
    background: var(--card);
    padding: 0 6px;
  }

  input,
  select {
    width: 100%;
    height: 44px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
    padding: 0 12px;
    background: #fff;
    font-size: 14px;
  }

  input:focus,
  select:focus {
    outline: 0;
    border-color: var(--blue);
    box-shadow: 0 0 0 3px rgba(40, 121, 254, 0.12);
  }

  /* efeito "float label" */

  input:not(:placeholder-shown) + label,
  input:focus + label,
  select:focus + label {
    top: 0;
    transform: translateY(-50%) scale(0.9);
    color: var(--muted);
  }
`;

export const InlineMsg = styled.div`
  margin-top: 12px;
  padding: 10px 12px;
  background: #ffecec;
  border: 1px solid #ffd0d0;
  color: var(--danger);
  border-radius: var(--radius-sm);
  font-size: 14px;
`;

export const ShippingOption = styled.label<{ active?: boolean }>`
  border: 1px solid var(--border);
  border-radius: 0;
  padding: 12px 30px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  background: #fff;

  /* escondemos o radio nativo, vamos usar o dot customizado */
  input {
    display: none;
  }

  .dot {
    width: 16px;
    height: 16px;
    border-radius: 999px;
    border: 1px solid var(--blue);

    ${(p) =>
      p.active &&
      css`
        background: var(--blue);
        box-shadow: inset 0 0 0 3px #fff;
      `}
  }
`;

export const ShippingFieldset = styled(Fieldset)`
  overflow: hidden;

  .label {
    color: var(--muted);
  }

  .option {
    border: 1px solid var(--border);
    border-radius: 0;
    padding: 12px 30px;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    background: #fff;

    input {
      accent-color: var(--blue);
      width: 16px;
      height: 16px;
    }
  }
`;
